// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__30fvg","selects":"Documents_selects__3do60"};